import { IStateType, IActionType } from "../../types";
import { combineReducers } from "redux";

import videoState from "./videoState";
import studyState from "./studyState";

export default combineReducers<IStateType, IActionType>({
  videoState: videoState,
  studyState: studyState,
});
